import { getQueryData } from "@nimble/react-requests/data/response-utils";

import { QuizStatusEnum } from "@/app/(discover)/candidate/(profile)/quiz/lib/types";
import { useQuizStatus } from "@/hooks/quiz/use-quiz";
import { QuizStatusResponse } from "@/lib/api-clients/recommendation-api-client";
import { useAuth } from "@/stores/use-auth";

interface ConditionalTakeQuizButtonContainerProps {
  button: React.ReactNode;
}

export default function ConditionalTakeQuizButtonContainer({
  button,
}: ConditionalTakeQuizButtonContainerProps) {
  const { user, isLoading: isAuthLoading } = useAuth();

  const userId = user?.id ?? null;
  const quizStatusQuery = useQuizStatus(userId);
  const quizStatusData = getQueryData<QuizStatusResponse>(quizStatusQuery);

  const shouldShowTakeQuizButton =
    (!user && !isAuthLoading) ||
    (!!quizStatusData && quizStatusData.status !== QuizStatusEnum.COMPLETE);

  if (!shouldShowTakeQuizButton) return null;

  return button;
}
